export default __webpack_public_path__ + "assets/mp3/020706fb94f68e2bf10fd37514843a76.mp3";